export const ModelIdSymbol = Symbol.for('Exodus:ModelId');
